module.exports = __webpack_public_path__ + "assets/img/tie-down-straps.783852a2.png";